module.exports = __webpack_public_path__ + "static/img/vod-bn-2.942c18d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vod-bn-2.jpg
// module id = oy1Z
// module chunks = 1